/**
 * Japanese (JPY) mock entity data for the marketing-site mockups.
 * Row shapes mirror the app's API rows (see shared-site-web/screens/*.js),
 * so the real column definitions and table components can render them.
 */

/** @type {Array<import('../../mock-data.js').MockAccount>} */
export const MOCK_ACCOUNTS_JA = [
	{ id: 'acc-checking', name: 'みどり銀行', accountType: 'Bank Account', currency: 'JPY', currencySymbol: '\u00A5', currencyDecimalPlaces: 0, balance: 289400, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-savings', name: '定期預金', accountType: 'Bank Account', currency: 'JPY', currencySymbol: '\u00A5', currencyDecimalPlaces: 0, balance: 1500000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-broker', name: 'NISA', accountType: 'Investment Account', currency: 'JPY', currencySymbol: '\u00A5', currencyDecimalPlaces: 0, balance: 7230000, principal: 7647555.1, updatedAt: '2026-08-08' },
	{ id: 'acc-pension', name: '個人年金', accountType: 'Pension', currency: 'JPY', currencySymbol: '\u00A5', currencyDecimalPlaces: 0, balance: 2800000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-property', name: 'マイホーム', accountType: 'Real Estate', currency: 'JPY', currencySymbol: '\u00A5', currencyDecimalPlaces: 0, balance: 35000000, principal: 28000000, updatedAt: '2026-08-08' },
	{ id: 'acc-flight', name: 'フライトマイル', accountType: 'Points/Miles', currency: 'MILES', currencySymbol: '\u2708', currencyDecimalPlaces: 0, balance: 84620, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-credit', name: 'クレジットカード', accountType: 'Credit Card', currency: 'JPY', currencySymbol: '\u00A5', currencyDecimalPlaces: 0, balance: 84200, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-joke', name: '宮古島証券', accountType: 'Investment Account', currency: 'JPY', currencySymbol: '\u00A5', currencyDecimalPlaces: 0, balance: 2000000, principal: 1098901.1, updatedAt: '2026-08-08' },
];

/**
 * Custom currencies (JPY base) for the currencies use case. MILES and HP
 * carry a manual rate so the currency table shows the manual marker "(M)".
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_CURRENCIES_JA = [
	{ code: 'JPY', isCustom: 0, name: '日本円', symbol: '\u00A5', decimalPlaces: 0, isBase: 1, rate: 1, manualRate: null },
	{ code: 'USD', isCustom: 0, name: '米ドル', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 150, manualRate: null },
	{ code: 'MILES', isCustom: 1, name: 'フライトマイル', symbol: '\u2708', decimalPlaces: 0, isBase: 0, rate: 2.2, manualRate: 2.2 },
	{ code: 'HP', isCustom: 1, name: 'ホテルポイント', symbol: 'P', decimalPlaces: 0, isBase: 0, rate: 1, manualRate: 1 },
	{ code: 'SM', isCustom: 1, name: 'ステータスマイル', symbol: 'SM', decimalPlaces: 0, isBase: 0, rate: 0, manualRate: 0 },
];

/**
 * Everyday currencies (JPY base) with auto-fetched rates for the
 * multi-currency use case.
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_RATES_JA = [
	{ code: 'JPY', isCustom: 0, name: '日本円', symbol: '\u00A5', decimalPlaces: 0, isBase: 1, rate: 1, manualRate: null },
	{ code: 'USD', isCustom: 0, name: '米ドル', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 150, manualRate: null },
	{ code: 'GBP', isCustom: 0, name: '英ポンド', symbol: '\u00A3', decimalPlaces: 2, isBase: 0, rate: 189.4, manualRate: null },
	{ code: 'EUR', isCustom: 0, name: 'ユーロ', symbol: '\u20AC', decimalPlaces: 2, isBase: 0, rate: 162.8, manualRate: null },
];
